import { Box, Link, List, ListItem, Typography } from "@mui/material";
import { faCircle, faUser } from "@fortawesome/pro-duotone-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import SpanTypography from "@/src/mui-custom/typography/span-typography/span-typography";
import type Author from "@/src/_types/Authors/author";

const ArticleAuthorsList = ({ authors }: { authors: Author[] }) => (
    <Box>
        <Typography display="flex" alignItems="center">
            <SpanTypography
                color="primary.main"
                mr={.25}
            >
                <FontAwesomeIcon
                    icon={faUser}
                />
            </SpanTypography>
            <SpanTypography ml={.25} color="text.primary">
                Author(s):
            </SpanTypography>
        </Typography>
        <List sx={{
            '& span': {
                color: 'text.secondary',
                fontSize: '.8rem'
            },
            '& a': {
                fontSize: '.8rem'
            }
        }}>
            {
                authors.map((author: Author, index: number) => {
                    const authorName = `${author.first_name} ${author.last_name}`;
                    return (
                        <ListItem
                            key={`article-author-${index}`}
                            sx={{
                                display: { lg: 'block', xl: 'flex' },
                                alignItems: 'center',
                                py: 0,
                                px: { lg: 0, xl: '16px' }
                            }}
                        >
                            <SpanTypography display={{ lg: 'none', xl: 'flex' }}>
                                <FontAwesomeIcon
                                    icon={faCircle}
                                    fontSize={5}
                                    style={{
                                        marginRight: 5
                                    }}
                                />
                            </SpanTypography>
                            <SpanTypography
                                whiteSpace="nowrap"
                                mr={.25}
                            >
                                {authorName}:
                            </SpanTypography>
                            <SpanTypography>[</SpanTypography>
                            <Link
                                href={`https://pubmed.ncbi.nlm.nih.gov/?term=${authorName.replace(' ', '+')}%5Bau%5D&dispmax=50`}
                            >
                                PubMed
                            </Link>
                            <SpanTypography>]</SpanTypography>
                            <SpanTypography>[</SpanTypography>
                            <Link
                                href={`https://scholar.google.com/citations?view_op=search_authors&mauthors=author:%27${authorName.replace(' ', '+')}%27&hl=en&oi=ao`}
                            >
                                Scholar
                            </Link>
                            <SpanTypography>]</SpanTypography>
                        </ListItem>
                    );
                })
            }
        </List>
    </Box>
);

export default ArticleAuthorsList;